import { memo } from 'react';
import { pluralize } from 'utils';

import { EditableGroupFields } from './editableGroupFields/editableGroupFields';

import { Button } from '@/shadcn/button';
import { GroupPatch, GroupSettingsQueryQuery } from '@/apollo/graphql';
import { TestId } from '@/types/testId';

type Props = {
  group: GroupSettingsQueryQuery['groupByRowId'];
  updateGroup: (group: GroupPatch) => void;
  setShowAddParticipantsModal: (show: boolean) => void;
  nbParticipants?: number;
  nbTeams?: number;
};

export const SubHeader = memo(
  ({
    group,
    updateGroup,
    setShowAddParticipantsModal,
    nbParticipants = 0,
    nbTeams = 0
  }: Props) => {
    return (
      <div className="border-border bg-card flex shrink-0 flex-col flex-nowrap items-start justify-between border-b px-5 py-4 md:flex-row md:items-center">
        <div className="flex h-[30px] w-full flex-row flex-nowrap items-center md:w-1/2">
          {group && (
            <EditableGroupFields group={group} updateGroup={updateGroup} />
          )}
        </div>
        <div className="mt-2.5 flex w-full flex-row flex-nowrap items-center justify-end gap-4 md:mt-0 md:w-auto">
          {group && (
            <p className="text-muted-foreground mx-1.5 inline-flex gap-2 text-sm">
              <span>{pluralize(nbTeams, 'team', false, true)} </span>|
              <span>
                {pluralize(nbParticipants, 'participant', false, true)}
              </span>
            </p>
          )}
          <Button
            onClick={() => setShowAddParticipantsModal(true)}
            data-testid={TestId.SubHeaderGroupSettings.AddParticipantsButton}
            aria-label="Add participants"
          >
            Add Participants
          </Button>
        </div>
      </div>
    );
  }
);
